/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const explain_why_body = () => `Dein Ticket steht auf deinen Namen. So bleibt es deins und niemand kommt mit einem kopierten Code hinein. Auf dieser Seite setzt du jedes Ticket auf einen Namen.`
